var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOverDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7392 17.5771L12.1872 1.04115C11.6592 0.129106 10.3391 0.129106 9.81114 1.04115L0.259138 17.5771C-0.268862 18.4892 0.379172 19.6411 1.43518 19.6411H20.5392C21.619 19.6411 22.267 18.489 21.739 17.5771H21.7392ZM10.6992 6.10515C11.2752 5.96117 11.8511 6.24912 12.1151 6.77715C12.2111 6.96917 12.2352 7.18513 12.2111 7.37715C12.163 7.97715 12.1391 8.57715 12.1151 9.20111C12.0671 10.1371 11.9951 11.097 11.9471 12.033C11.9231 12.321 11.9231 12.6091 11.899 12.921C11.8751 13.4251 11.491 13.8089 10.987 13.8089C10.507 13.8089 10.099 13.4249 10.0749 12.9449C10.0029 11.4809 9.90684 10.0169 9.83485 8.55293C9.81091 8.1689 9.78681 7.76093 9.76287 7.37689C9.7632 6.80115 10.1472 6.24923 10.6992 6.10523L10.6992 6.10515ZM11.0112 17.0972C10.3392 17.0972 9.81123 16.5452 9.81123 15.8732C9.81123 15.2012 10.3632 14.6492 11.0352 14.6492C11.7072 14.6492 12.2352 15.2012 12.2352 15.8973C12.2112 16.545 11.6593 17.0971 11.0112 17.0971V17.0972Z",
    fill: "#ECC94B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOverDue);
export default __webpack_public_path__ + "static/media/BookOverDue.0f24a1cd4df7a81f1a7f934977e17e8a.svg";
export { ForwardRef as ReactComponent };